module.exports = __webpack_public_path__ + "img/luxembourg.c6c7468b.svg";